import { render } from "./CreateUserApp.vue?vue&type=template&id=8bf95ce2&scoped=true"
import script from "./CreateUserApp.vue?vue&type=script&lang=js"
export * from "./CreateUserApp.vue?vue&type=script&lang=js"

import "./CreateUserApp.vue?vue&type=style&index=0&id=8bf95ce2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8bf95ce2"]])

export default __exports__